<template>
  <div>
    <q-item
      :class="[
        `justify-${row.justifyContent ? row.justifyContent : 'center'}`,
        row.class,
        rowClass
      ]"
      :style="[row.styles]"
      v-for="(row, index) in data"
      :key="index"
    >
      <template v-for="(key, indexHeader) in keys">
        <div
          :set="(item = row.list[key])"
          :key="`${index}-${indexHeader}`"
          v-if="row.list[key]"
          :style="{
            width: `calc(100% / ${keys.length})`,
          }"
          class="item column justify-center items-center"
        >
          <q-separator
            class="full-height"
            vertical
            v-if="indexHeader"
            :style="{ backgroundColor: getSeparatorColor(indexHeader) }"
          />
          <q-item-section
            :class="[
              'full-width',
              `text-${getTextAlign(item, indexHeader)}`,
              item.class,
            ]"
            :style="[item.styles]"
          >
            <div
              :class="['overline text-uppercase', item.overline.class]"
              :style="[item.overline.styles]"
              v-if="item.overline"
              v-html="item.overline.content"
            ></div>

            <div
              :class="['title text-uppercase', item.title.class]"
              :style="[item.title.styles]"
              v-if="item.title"
              v-html="item.title.content"
            ></div>

            <div
              :class="{
                'q-mt-auto': item.title || item.overline,
              }"
            >
              <div
                :class="['caption', item.caption.class]"
                :style="[{ height: contentCaptionHeight }, item.caption.styles]"
                ref="content-caption"
                v-if="item.caption"
                v-html="item.caption.content"
              ></div>

              <div
                :class="['body', [item.body.class]]"
                :style="[item.body.styles]"
                v-if="item.body"
              >
                <div
                  v-for="(bodyContent, indexBody) in item.body.content"
                  :key="`${index}-${indexHeader}-${indexBody}`"
                  v-html="bodyContent"
                ></div>
              </div>
            </div>
          </q-item-section>
        </div>
      </template>
    </q-item>
  </div>
</template>

<script>
import { colors } from "quasar";
const { changeAlpha } = colors;

export default {
  name: "DCompareListRows",
  data() {
    return {
      contentCaptionHeight: "auto",
    };
  },
  props: {
    keys: {
      type: Array,
      required: true,
    },
    data: {
      type: Array,
      required: true,
    },
    rowClass: {
      type: String,
      required: false,
      default: "",
    },
  },
  mounted() {
    if (!this.$refs["content-caption"]) {
      return;
    }

    this.contentCaptionHeight = `${Math.max(
      ...this.$refs["content-caption"].map((el) => el.scrollHeight),
    )}px`;
  },
  methods: {
    getTextAlign(item, index) {
      if (!item.textAlign) {
        return !index ? "left" : "center";
      }

      return item.textAlign;
    },
    getSeparatorColor(index) {
      return index !== this.keys.length - 1
        ? "#E0E0E0"
        : changeAlpha("#E0E0E0", 0.5);
    },
  },
};
</script>
